import { render } from "./PagamentoFallito.vue?vue&type=template&id=277731a5&scoped=true"
import script from "./PagamentoFallito.vue?vue&type=script&lang=js"
export * from "./PagamentoFallito.vue?vue&type=script&lang=js"

import "./PagamentoFallito.vue?vue&type=style&index=0&id=277731a5&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277731a5"]])

export default __exports__